var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00547 0C8.19077 0 7.27764 0.630747 7.27764 1.4788V3.71025C3.13852 4.4947 0 8.03534 0 12.2756C0 17.0883 4.0407 21 9 21C13.9593 21 18 17.083 18 12.2756C18 8.03534 14.867 4.4947 10.7224 3.71025V1.4788C10.7224 0.636047 9.80924 0 8.99453 0H9.00547ZM8.29465 1.4788C8.29465 1.25619 8.6774 0.985858 9.00547 0.985858C9.33354 0.985858 9.71628 1.25089 9.71628 1.4788V10.1714C9.71628 10.394 9.32807 10.6643 9.00547 10.6643C8.68287 10.6643 8.29465 10.3993 8.29465 10.1714V1.4788ZM9.00547 11.6502C9.82017 11.6502 10.7333 11.0194 10.7333 10.1714V7.4576C12.7892 8.15195 14.2655 10.0495 14.2655 12.2756C14.2655 15.0901 11.9034 17.3746 9.00547 17.3746C6.10753 17.3746 3.74544 15.0848 3.74544 12.2756C3.74544 10.0495 5.22722 8.15195 7.27764 7.4576V10.1714C7.27764 11.0141 8.19077 11.6502 9.00547 11.6502ZM16.9885 12.2703C16.9885 16.5424 13.407 20.0141 9 20.0141C4.59295 20.0141 1.01154 16.5424 1.01154 12.2703C1.01154 8.57597 3.69623 5.48056 7.27217 4.71201V6.42403C4.64763 7.15548 2.72296 9.49823 2.72296 12.2703C2.72296 15.6254 5.53888 18.3551 9 18.3551C12.4611 18.3551 15.277 15.6254 15.277 12.2703C15.277 9.49823 13.3524 7.15017 10.7278 6.42403V4.71201C14.3038 5.48056 16.9885 8.57597 16.9885 12.2703Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnOff);
export default __webpack_public_path__ + "static/media/onOff.9fb762e45f733382c50320c7bc5bd1e1.svg";
export { ForwardRef as ReactComponent };